<template>
    <div class="addinsurer">
      <TableToolTemp :toolListProps="{ toolTitle: '增加被保险人' }"> </TableToolTemp>
      <el-tabs type="border-card" v-model="activeName" ref="target" v-if="showEdited">
        <el-tab-pane label="增加被保人" name="edited">
          <div class="addtable">
            <el-form
              :model="addJsonForm"
              ref="addJsonForm"
              :rules="addJsonForm.addJsonRules"
              :inline="true"
              label-width="108px"
            >
              <!--  -->
              <el-table :data="addJsonForm.params" border @selection-change="handleSelectionChange" :max-height="500">
                <el-table-column type="selection"> </el-table-column>
                <!-- <el-table-column align="center" width="150">
                  <template slot="header">
                    <span>被保人序号</span>
                  </template>
                  <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column> -->
                <el-table-column align="center" width="150">
                  <template slot="header">
                    <span>被保人姓名</span>
                    <i style="color: #f56c6c">*</i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'params.' + scope.$index + '.insuredName'"
                      :rules="addJsonForm.addJsonRules.insuredName"
                    >
                      <el-input placeholder="被保险人姓名" v-model="scope.row.insuredName"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
  
                <el-table-column align="center" width="200">
                  <template slot="header">
                    <span>证件类型</span>
                    <i style="color: #f56c6c">*</i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'params.' + scope.$index + '.insuredCardType'"
                      :rules="addJsonForm.addJsonRules.insuredCardType"
                    >
                      <el-select
                        clearable
                        placeholder="证件类型"
                        v-model="scope.row.insuredCardType"
                        @change="insuredCardTypeselectchange(scope.$index, scope.row.insuredCardType)"
                      >
                        <el-option
                          v-for="(ite, ind) in filterIdCard(dicMap['gen.identityType'])"
                          :key="ind"
                          :label="ite.dicItemName"
                          :value="ite.dicItemCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
  
                <el-table-column align="center" width="220">
                  <template slot="header">
                    <span>证件号码</span>
                    <i style="color: #f56c6c">*</i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'params.' + scope.$index + '.insuredCardNo'"
                      :rules="addJsonForm.addJsonRules.insuredCardNo"
                    >
                      <el-input placeholder="证件号码" v-model="scope.row.insuredCardNo"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
  
                <el-table-column align="center" width="120">
                  <template slot="header">
                    <span>性别</span>
                    <i style="color: #f56c6c">*</i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'params.' + scope.$index + '.gender'" :rules="addJsonForm.addJsonRules.gender">
                      <el-select clearable placeholder="性别" v-model="scope.row.gender" :disabled="scope.row.disable">
                        <el-option
                          v-for="(ite, ind) in dicMap['gen.gender']"
                          :key="ind"
                          :label="ite.dicItemName"
                          :value="ite.dicItemCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
  
                <el-table-column align="center" width="170">
                  <template slot="header">
                    <span>出生日期</span>
                    <i style="color: #f56c6c">*</i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'params.' + scope.$index + '.birthday'"
                      :rules="addJsonForm.addJsonRules.birthday"
                    >
                      <el-date-picker
                        :disabled="scope.row.disable"
                        style="width: 150px"
                        v-model="scope.row.birthday"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :picker-options="{
                          disabledDate: (date) => {
                            return date && date.valueOf() > new Date();
                          },
                        }"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
  
                <el-table-column align="center" width="120">
                  <template slot="header">
                    <span>与员工关系</span>
                    <i style="color: #f56c6c">*</i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'params.' + scope.$index + '.relaWithStaff'"
                      :rules="addJsonForm.addJsonRules.relaWithStaff"
                    >
                      <el-select
                        clearable
                        placeholder="与员工关系"
                        v-model="scope.row.relaWithStaff"
                        @change="staffselectchange(scope.$index, scope.row.relaWithStaff)"
                      >
                        <el-option
                          v-for="(ite, ind) in handleFilterRelation(dicMap['bbc.preservation.rela'])"
                          :key="ind"
                          :label="ite.dicItemName"
                          :value="ite.dicItemCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
  
                <el-table-column align="center" width="130">
                  <template slot="header">
                    <span>保险计划</span>
                    <i style="color: #f56c6c">*</i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'params.' + scope.$index + '.planId'" :rules="addJsonForm.addJsonRules.planId">
                      <el-select
                        clearable
                        placeholder="保险计划"
                        v-model="scope.row.planId"
                        @change="planselectchange(scope.$index, scope.row.planId)"
                      >
                        <el-option
                          v-for="(ite, ind) in planArr"
                          :key="ind"
                          :label="ite.planName"
                          :value="ite.planId"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
  
                <el-table-column align="center" width="130">
                  <template slot="header">
                    <span>职业类别</span>
                    <i style="color: #f56c6c">*</i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'params.' + scope.$index + '.occupationType'"
                      :rules="addJsonForm.addJsonRules.occupationType"
                    >
                      <el-select clearable placeholder="职业类别" v-model="scope.row.occupationType">
                        <el-option
                          v-for="(ite, ind) in dicMap['bbc.occupation.type']"
                          :key="ind"
                          :label="ite.dicItemName"
                          :value="ite.dicItemCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
  
                <el-table-column align="center" width="130">
                  <template slot="header">
                    <span>医保标识</span>
                    <i style="color: #f56c6c">*</i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'params.' + scope.$index + '.socialSecurity'"
                      :rules="addJsonForm.addJsonRules.socialSecurity"
                    >
                      <el-select clearable placeholder="医保标识" v-model="scope.row.socialSecurity">
                        <el-option
                          v-for="(ite, ind) in dicMap['gcbs.social.insurance']"
                          :key="ind"
                          :label="ite.dicItemName"
                          :value="ite.dicItemCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
  
                <el-table-column align="center" width="160">
                  <template slot="header">
                    <span>移动电话</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-input placeholder="移动电话" v-model="scope.row.insuredPhoneNo"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="150">
                  <template slot="header">
                    <span>国籍/地区</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-select v-model="scope.row.nation" filterable placeholder="国籍/地区" clearable>
                        <el-option
                        v-for="item in nationOptions"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                        </el-option>
                    </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="250">
                  <template slot="header">
                    <span>来往内地通行证号码</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-input placeholder="来往内地通行证号码" v-model="scope.row.passNo"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="200">
                  <template slot="header">
                    <span>主被保人证件类型</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item v-if="scope.row.relaWithStaff == '01' || scope.row.relaWithStaff == ''">
                      <el-select clearable placeholder="证件类型" v-model="scope.row.subInsuredCardType">
                        <el-option
                          v-for="(ite, ind) in filterIdCard(dicMap['gen.identityType'])"
                          :key="ind"
                          :label="ite.dicItemName"
                          :value="ite.dicItemCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-else
                      :prop="'params.' + scope.$index + '.subInsuredCardType'"
                      :rules="addJsonForm.addJsonRules.subInsuredCardType"
                    >
                      <el-select clearable placeholder="证件类型必填" v-model="scope.row.subInsuredCardType">
                        <el-option
                          v-for="(ite, ind) in filterIdCard(dicMap['gen.identityType'])"
                          :key="ind"
                          :label="ite.dicItemName"
                          :value="ite.dicItemCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <!--  -->
                  </template>
                </el-table-column>
  
                <el-table-column align="center" width="220">
                  <template slot="header">
                    <span>主被保险人证件号码</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item v-if="scope.row.relaWithStaff == '01'">
                      <el-input placeholder="证件号码" v-model="scope.row.subInsuredCardNo"></el-input>
                    </el-form-item>
                    <el-form-item
                      v-else
                      :prop="'params.' + scope.$index + '.subInsuredCardNo'"
                      :rules="addJsonForm.addJsonRules.subInsuredCardNo"
                    >
                      <el-input placeholder="证件号码" v-model="scope.row.subInsuredCardNo"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column align="center" width="150">
                  <template slot="header">
                    <span>主被保人姓名</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-input placeholder="主被保人姓名" v-model="scope.row.subInsuredName"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="220">
                  <template slot="header">
                    <span>生效起期</span>
                    <i style="color: #f56c6c">*</i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'params.' + scope.$index + '.effectiveTime'"
                      :rules="addJsonForm.addJsonRules.effectiveTime"
                    >
                      <el-date-picker
                        style="width: 150px"
                        v-model="scope.row.effectiveTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :picker-options="{
                          disabledDate: (date) => {
                            return date && date.valueOf() >+new Date() + 24*3600*1000 || (date.valueOf()<+new Date() - 59*24*3600*1000);
                          },
                        }"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="220">
                  <template slot="header">
                    <span>异常原因</span>
                  </template>
                  <template slot-scope="scope">
                    <span>{{ scope.row.unusualReason }}</span>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="deleterow(scope)">删除</el-button>
                    <el-button
                      type="text"
                      size="small"
                      v-if="scope.row.unusualReason == '重复'"
                      @click="recover(scope.row)"
                      >确认覆盖</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </div>
          <div>
            <el-button type="text" icon="iconfont icondt8" @click="addrow">增加新一行</el-button>
          </div>
          <div>
            <el-button type="text" icon="iconfont icondt24" v-if="selectArr.length >= 2" @click="deleterowBymultiple"
              >批量删除</el-button
            >
          </div>
          <div class="save-btn">
            <el-button plain type="primary" @click="saveInsurer">保存</el-button>
            <el-button type="primary" @click="submitToGcbs">提交</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="批量增加" name="upload">
          <el-form label-position="left">
            <el-form-item>
              <el-row>
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  action
                  :on-remove="handleRemove"
                  :on-success="handlesuccess"
                  :before-upload="handleBeforeupload"
                  :http-request="handleUploadForm"
                  :file-list="importdata"
                  :auto-upload="false"
                  :limit="2"
                  :on-change="uploadChange"
                  accept='.xlsx,.xls'
                >
                  <el-button slot="trigger" type="primary">选择导入模板</el-button>
                </el-upload>
                <el-button type="primary" @click="submitUpload">批量导入</el-button>
              </el-row>
            </el-form-item>
            <div>
              <el-button type="text" @click="downLoadTemplate">下载导入模版</el-button>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
  
      <!-- 提交到团财成功后，显示的列表 -->
      <div class="gcbs-wrapper" v-if="!showEdited">
        <Table :data="tableData" :options="listDataOptions" align="center" height="500"></Table>
        <Pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pageData="initParam"
          :total="total"
        ></Pagination>
        <div class="save-btn">
          <el-button plain type="primary" @click="commitToxf"> 确认提交</el-button>
          <!-- <el-button type="primary" @click="showEdited = true">返回</el-button> -->
          <el-button type="primary" @click="gobackEdit">返回</el-button>
        </div>
      </div>
      <!-- 提交到 幸福 成功和异常的弹窗-->
      <DtPopup
        :isShow.sync="xfPopupShow"
        @close="gohistory(xfPopupShowtitle, xfporpInfo)"
        :title="xfPopupShowtitle"
        :footer="false"
      >
        <div class="popup-text">
          <span v-if="xfPopupShowtitle == '提交成功'">保全号：{{ xfporpInfo }}</span>
          <span v-if="xfPopupShowtitle == '提交失败'">失败原因：{{ xfporpInfo }}</span>
        </div>
        <div style="text-align: center; margin-top: 20px; margin-bottom: 20px">
          <el-button type="primary" @click="gohistory(xfPopupShowtitle, xfporpInfo)">返回</el-button>
        </div>
      </DtPopup>
    </div>
  </template>
  <script>
  import TableToolTemp from '@/components/layouts/TableToolTemp';
  import Table from '@/components/layouts/table';
  import Pagination from '@/components/layouts/Pagination';
  import DtPopup from '@/components/layouts/DtPopup';
  import { validateIdCard } from '@/utils/utils';
  import dayjs from 'dayjs';
  import {
    preservationdownload,
    preservationupload,
    preservationgetDetail,
    preservationgetPlan,
    preservationsaveInsured,
    preservationsubmitToGcbs,
    preservationinsuredList,
    preservationconfirmCover,
    preservationdelete,
    preservationsubmitToXfrs,
    preservationbatchDelete,
    preservationedit,
    getTbalNation,
    submitToTbal
  } from '@/api/securityManage';
  import { myMixin } from '@/mixins';
  export default {
    mixins: [myMixin],
    components: {
      TableToolTemp,
      Table,
      Pagination,
      DtPopup,
    },
    computed: {
      dicMap() {
        return this.$store.state.dicMap;
      },
    },
    watch: {
      activeName(val) {
        if (val == 'upload') {
          this.saveInsurer();
        }
      },
    },
    data() {
      return {
        xfPopupShow: false,
        xfPopupShowtitle: '提交成功',
        xfporpInfo: {},
        dicArr: [
          'gen.gender', //  性别
          'gen.identityType', // 证件类型
          'bbc.occupation.type', // 职业类别
          'bbc.preservation.rela', //与职员关系关系
          'gcbs.rela.with.staff', //与职员关系关系
          'gcbs.preservation.status', //保全状态
          'gcbs.social.insurance', //有无社保
        ],
        activeName: 'edited',
        addJsonForm: {
          params: [
            {
              subInsuredCardType: '',
              subInsuredCardNo: '',
              insuredName: '',
              insuredCardType: '',
              insuredCardNo: '',
              gender: '',
              birthday: '',
              relaWithStaff: '',
              planName: '',
              planId: '',
              occupationType: '',
              socialSecurity: '',
              insuredPhoneNo: '',
              isLocal: true,
              disable: false,
              index: 1,
              effectiveTime:dayjs().add(1, "day").format("YYYY-MM-DD"),
              subInsuredName:'',
              nation:"",
              passNo:''
            },
          ],
          addJsonRules: {
            insuredName: [{ required: true, message: '请填写被保人姓名', trigger: 'blur' }],
            insuredCardType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
            insuredCardNo: [
              { required: true, message: '请填写证件号码', trigger: 'blur' },
              { validator: this.analysisIdCard, trigger: 'blur' },
            ],
            gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
            birthday: [{ required: true, message: '请选择出生日期', trigger: ['change', 'blur'] }],
            relaWithStaff: [{ required: true, message: '请选择员工关系', trigger: 'change' }],
            planId: [{ required: true, message: '请选择保险计划', trigger: 'change' }],
            occupationType: [{ required: true, message: '请选择职业类别', trigger: 'change' }],
            socialSecurity: [{ required: true, message: '请选择有无医保', trigger: 'change' }],
            subInsuredCardType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
            subInsuredCardNo: [{ required: true, message: '请填写证件号码', trigger: 'blur' }],
            effectiveTime: [{ required: true, message: '请选择日期', trigger: ['change', 'blur'] }],
          },
        },
        index: 1,
        importdata: [],
        initParam: {
          pageNum: 1,
          pageSize: 10,
          param: {
            preservationId: this.$route.query.preservationId,
            preservationType: this.$route.query.preservationType,
          },
        },
        gcbsParam: {
          pageNum: 1,
          pageSize: 10,
          param: {
            preservationId: this.$route.query.preservationId,
            preservationType: this.$route.query.preservationType,
            policyId: this.$route.query.policyId,
          },
        },
        total: 0,
        planArr: [],
        showEdited: true, // 标示当前是添加还是已经提交到团财
        tableData: [],
        listDataOptions: [
          {
            prop: 'insuredName',
            label: '被保人姓名',
          },
          {
            prop: 'insuredCardType',
            label: '证件类型',
            dic: 'gen.identityType',
          },
          {
            prop: 'insuredCardNo',
            label: '证件号码',
          },
          {
            prop: 'gender',
            label: '性别',
            dic: 'gen.gender',
          },
          {
            prop: 'birthday',
            label: '出生日期',
          },
          {
            prop: 'relaWithStaff',
            label: '与员工关系',
            dic: 'gcbs.rela.with.staff',
          },
          {
            prop: 'planName',
            label: '保险计划',
          },
          {
            prop: 'occupationType',
            label: '职业类别',
            dic: 'bbc.occupation.type',
          },
          {
            prop: 'socialSecurity',
            label: '医保标识',
            dic: 'gcbs.social.insurance',
          },
          {
            prop: 'insuredPhoneNo',
            label: '移动电话',
          },
          {
            prop: 'nation',
            label: '国籍/地区',
          },
          {
            prop: 'passNo',
            label: '来往内地通行证号码',
          },
          {
            prop: 'subInsuredCardType',
            label: '主被保险人证件类型',
            dic: 'gen.identityType',
          },
          {
            prop: 'subInsuredCardNo',
            label: '主被保险人证件号码',
          },
          {
            prop: 'subInsuredName',
            label: '主被保人姓名',
          },
         
          {
            prop: 'effectiveTime',
            label: '生效日期',
          },
        ],
        selectArr: [], //批量删除的数组
        file: null,
        nationOptions:[],
        filterRelation:[]
      };
    },
    methods: {
      filterIdCard(arr){
      // 身份证,军官证,港澳居民来往内地通行证,护照,台湾居民来往大陆通行证,出生证明,外国人永久居留身份证,港澳居民居住证,台湾居民居住证
      // ['01','07','05','04','06','03','18','12','11']
      let tbCard=['01','07','05','04','06','03','18','12','11']
      let filterArr=arr&&arr.filter(item=>{
        return tbCard.find(ele=>ele==item.dicItemCode)
      })
      return filterArr
    },
       async nationInit(){
        let res=await getTbalNation({})
        if(res&&Array.isArray(res)){
            this.nationOptions=res
        }
        },
      uploadChange(file, fileList) {
        this.file = file.raw;
        if (fileList.length > 1) {
          fileList.splice(0, 1);
        }
      },
      handleRemove() {
        this.importdata = [];
        this.file = null;
      },
      handlesuccess(response) {
        if (response.resp_code == 0) {
          this.$message('导入成功');
        } else {
          this.$message.error(response.resp_msg);
        }
  
        this.importdata = [];
      },
      handleBeforeupload(file) {
         const isXLS =
          file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          file.type === 'application/vnd.ms-excel';
          if (!isXLS) this.$message.error('上传文件只能是xls或xlsx格式!');
          return isXLS
      },
      handleUploadForm(params) {
        let formDate = new FormData();
        formDate.append('policyId', this.$route.query.policyId);
        formDate.append('preservationId', this.$route.query.preservationId);
        formDate.append('file', params.file);
        formDate.append('type', this.$route.query.type);
        formDate.append('comId', this.$route.query.comId,);
        this.$confirm('本操作将覆盖现有数据，是否继续?', '提示', {
          confirmButtonText: '确定覆盖',
          cancelButtonText: '取消覆盖',
          type: 'warning',
        })
          .then(() => {
            formDate.append('cover', '1');
            preservationupload(formDate).then((res) => {
              if (res && res.resp_code == 0) {
                this.getAll();
                this.activeName = 'edited';
              }
            });
          })
          .catch(() => {
            formDate.append('cover', '0');
            preservationupload(formDate).then((res) => {
              if (res && res.resp_code == 0) {
                this.getAll();
                this.activeName = 'edited';
              }
            });
          });
      },
      submitUpload() {
        if (!this.file) {
          this.$message.error('请先选择模板');
          return;
        }
        this.$refs.upload.submit();
      },
      downLoadTemplate() {
        preservationdownload('批量加人导入模板.xlsx', {
          type: this.$route.query.type,
          comId:this.$route.query.comId,
        });
      },
      getdetail() {
        //带分页
        preservationgetDetail(this.gcbsParam).then((response) => {
          if (response && Array.isArray(response.list)) {
            this.tableData = response.list.map((element) => {
              // 保险计划转换
              let planNamearr = this.planArr.filter((item) => {
                return item.planId == element.planId;
              });
              planNamearr[0] && (element.planName = planNamearr[0].planName);
              // 国籍转换
              let Tvalue=this.nationOptions.find(ele=>ele.key===element.nation)
              element.nation= Tvalue?Tvalue.value:'中国'
              return element;
            });
            this.total = response.total;
          }
        });
      },
      getAll(bool = false) {
        // 不带分页 ,返回所有数据
        let { preservationId, preservationType } = this.$route.query;
        preservationinsuredList({ preservationId, preservationType }).then((res) => {
          if (res && Array.isArray(res)&&res.length) {
            let filterRes = this.addJsonForm.params.filter((item) => {
              return item.isLocal == true;
            });
            filterRes = filterRes.filter((item) => {
              return (
                item.subInsuredCardType != '' ||
                item.subInsuredCardNo != '' ||
                item.insuredName != '' ||
                item.insuredCardType != '' ||
                item.insuredCardNo != '' ||
                item.gender != '' ||
                item.birthday != '' ||
                item.relaWithStaff != '' ||
                item.planId != '' ||
                item.occupationType != '' ||
                item.socialSecurity != '' ||
                item.insuredPhoneNo != ''
              );
            });
  
            res = res.map((item) => {
              item.disable = item.insuredCardType == '01' && item.insuredCardNo ? true : false;
              return item;
            });
            let configres=[]
            res.map(item=>{
              configres.push({
              subInsuredCardType: item.subInsuredCardType,
              subInsuredCardNo: item.subInsuredCardNo,
              insuredName: item.insuredName,
              insuredCardType: item.insuredCardType,
              insuredCardNo: item.insuredCardNo,
              gender: item.gender,
              birthday: item.birthday,
              relaWithStaff: item.relaWithStaff,
              planName: item.planName,
              planId: item.planId,
              occupationType: item.occupationType,
              socialSecurity: item.socialSecurity,
              insuredPhoneNo: item.insuredPhoneNo,
              disable: item.disable,
              effectiveTime:item.effectiveTime||dayjs().add(1, "day").format("YYYY-MM-DD"),
              unusualReason:item.unusualReason,
              middlewareInsuredId:item.insuredId,
              oldmiddlewareInsuredId:item.oldInsuredId,
              nation:item.nation,
              subInsuredName:item.subInsuredName,
              passNo:item.passNo
              })
            })
            this.addJsonForm.params = bool ? [...filterRes, ...configres] : configres;
            this.$refs.addJsonForm.clearValidate();
          }
        });
      },
      async getplan() {
        let res = await preservationgetPlan({ policyId: this.$route.query.policyId });
        if (res) {
          //返回的是map，转为array
          for (let key in res) {
            this.planArr.push({
              planName: key,
              planId: res[key],
            });
          }
          // 新增约定  根据计划内显示的 计划名称 含有 ['子女','配偶','父母']，则关系过滤对应显示
          let filterRelation=['本人'];
          this.planArr.map(item=>{
            if(item.planName.includes('子女')){
              filterRelation.push('子女')
            }else if(item.planName.includes('配偶')){
              filterRelation.push('配偶')
            }else if(item.planName.includes('父母')){
              filterRelation.push('父母')
            }
          })
          this.filterRelation=filterRelation
        }
      },
      handleFilterRelation(arr){
        let filterRelation=this.filterRelation;
        let result=[]
        result=arr.filter(item=>filterRelation.includes(item.dicItemName))
        return result
      },
      planselectchange(index, planId) {
        let planNamearr = this.planArr.filter((item) => {
          return item.planId == planId;
        });
        let planName = planNamearr[0].planName;
        this.addJsonForm.params[index].planName = planName;
      },
      staffselectchange(index, relaWithStaff) {
        if (relaWithStaff == '01') {
          // 本人 移除校验结果
          this.$refs.addJsonForm.clearValidate('params.' + index + '.subInsuredCardType');
          this.$refs.addJsonForm.clearValidate('params.' + index + '.subInsuredCardNo');
        }
      },
      insuredCardTypeselectchange(index, val,) {
        if (val != '01'|| val !='11'||val != '12') {
          // 不是身份证类型 
          this.addJsonForm.params[index].disable = false;
          
        } else {
            // 选择身份证类型 则国籍字段为中国
            val=='01'&&(this.addJsonForm.params[index].nation='CN')  
          // 身份证号码合规则
          let value = this.addJsonForm.params[index].insuredCardNo;
  
          if (validateIdCard(value)) {
            var year = value.substr(6, 4);
            var month = value.substr(10, 2);
            var day = value.substr(12, 2);
            var sex = value.substr(16, 1);
            this.addJsonForm.params[index].birthday = year + '-' + month + '-' + day;
            this.addJsonForm.params[index].gender = sex % 2 == 0 ? '2' : '1';
            this.addJsonForm.params[index].disable = true;
          }
        }
      },
      addrow() {
        let index = this.index + 1;
        this.index = index;
        this.addJsonForm.params.push({
          subInsuredCardType: '',
          subInsuredCardNo: '',
          insuredName: '',
          insuredCardType: '',
          insuredCardNo: '',
          gender: '',
          birthday: '',
          relaWithStaff: '',
          // planName: '',
          planId: '',
          occupationType: '',
          socialSecurity: '',
          insuredPhoneNo: '',
          isLocal: true,
          disable: false,
          index,
          effectiveTime:dayjs().add(1, "day").format("YYYY-MM-DD"),
          subInsuredName:'',
          nation:"",
              passNo:''
        });
      },
      deleterow(data) {
        let rowData = this.addJsonForm.params;
        // if (rowData.length <= 1) {
        //   this.$message.error('再删就没数据了');
        //   return;
        // } else {
        if (data.row.isLocal) {
          //手动增加得数据
          this.addJsonForm.params = rowData.filter((item, index) => {
            return index != data.$index;
          });
        } else {
          //导入的数据删除
          let { preservationId } = this.$route.query;
          preservationdelete({
            insuredId: data.row.middlewareInsuredId,
            preservationId,
            insuredCardNo: data.row.insuredCardNo,
            oldInsuredId:data.row.oldmiddlewareInsuredId,
          }).then((res) => {
            if (res && res.resp_code == 0) {
              this.addJsonForm.params = this.addJsonForm.params.filter((item, index) => {
                return item.middlewareInsuredId != data.row.middlewareInsuredId;
              });
            }
          });
        }
        // 如果删除后列表为空 为其添加一条空数据
        if (this.addJsonForm.params.length <= 0) {
          this.addrow();
        }
      },
      // 批量删除，区分导入和手动添加
      deleterowBymultiple() {
        let selectArr = this.selectArr;
        //区分手动添加和导入数据 带index 得为手动添加  带insuredId为导入数据
        let handlearr = selectArr.filter((item) => {
          return item.index;
        });
        let importarr = selectArr.filter((item) => {
          return item.middlewareInsuredId;
        });
        //手动添加得直接删除
        if (handlearr && handlearr.length) {
          for (let i = 0; i < handlearr.length; i++) {
            this.addJsonForm.params = this.addJsonForm.params.filter((item) => {
              return item.index != handlearr[i].index;
            });
          }
        }
        //导入的数据 调用批量删除接口
        if (importarr && importarr.length) {
          preservationbatchDelete(importarr).then((res) => {
            for (let i = 0; i < importarr.length; i++) {
              this.addJsonForm.params = this.addJsonForm.params.filter((item) => {
                return item.middlewareInsuredId != importarr[i].middlewareInsuredId;
              });
            }
          });
        }
        // 如果删除后列表为空 为其添加一条空数据
        if (this.addJsonForm.params.length <= 0) {
          this.addrow();
        }
      },
      handleSelectionChange(val) {
        this.selectArr = val;
      },
      recover(data) {
        preservationconfirmCover({
          insuredId: data.middlewareInsuredId,
          oldInsuredId: data.oldmiddlewareInsuredId,
        }).then((res) => {
          if (res && res.resp_code == 0) {
            this.getAll(false);
          }
        });
      },
  
      saveInsurer() {
        // 保存不校验
        for (let key in this.addJsonForm.addJsonRules) {
          this.addJsonForm.addJsonRules[key][0].required = false;
        }
        //保存被保人
        let { policyId, preservationId, type, comId} = this.$route.query;
        let status = type;
        let list = this.addJsonForm.params.filter((item) => {
          // 过滤掉全是空数据的item
          return (
            item.subInsuredCardType != '' ||
            item.subInsuredCardNo != '' ||
            item.insuredName != '' ||
            item.insuredCardType != '' ||
            item.insuredCardNo != '' ||
            item.gender != '' ||
            item.birthday != '' ||
            item.relaWithStaff != '' ||
            item.planId != '' ||
            item.occupationType != '' ||
            item.socialSecurity != '' ||
            item.insuredPhoneNo != ''
          );
        });
        // this.$refs.addJsonForm.validate((valid) => {
        //   if (valid) {
        list &&
          list.length &&
          preservationsaveInsured({
            policyId,
            preservationId,
            status,
            list,
            comId
          }).then((res) => {
            // 掉刷新接口
            if (res) {
              this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success',
              });
              this.getAll();
              this.$refs.addJsonForm.clearValidate();
            }
          });
        //   }
        // });
      },
      submitToGcbs() {
        //提交到团财
        for (let key in this.addJsonForm.addJsonRules) {
          this.addJsonForm.addJsonRules[key][0].required = true;
        }
        let { preservationId, type, policyId ,policyCode,comId} = this.$route.query;
        this.$refs.addJsonForm.validate((valid) => {
          if (valid) {
            preservationsubmitToGcbs({
              policyId,
              preservationId,
              type,
              list: this.addJsonForm.params,
              policyCode,
              comId
            }).then((res) => {
              if (res && res.resp_code == 0) {
                this.showEdited = false;
                this.getdetail();
              } else {
                this.getAll(false);
              }
            });
          }
        });
      },
      // 提交到太保安联
      commitToxf() {
        let { policyId, preservationId, type } = this.$route.query;
        submitToTbal({
          policyId,
          type,
          preservationId,
        }).then((res) => {
          if (res&&res.code == 1) {
            //失败
            this.xfPopupShow = true;
            this.xfPopupShowtitle = '提交失败';
            this.xfporpInfo = res.msg;
          } else if (res&&res.code == 0) {
            //成功
            this.xfPopupShow = true;
            this.xfPopupShowtitle = '提交成功';
            this.xfporpInfo = res.msg;
          }
        });
      },
      gohistory() {
        let { policyId, policyCode } = this.$route.query;
        this.$router.replace({
          name: 'historyTB',
          query: {
            policyId,
            policyCode,
            comId:this.$route.query.comId,
          },
        });
      },
      handleSizeChange(val) {
        this.gcbsParam.pageNum = 1;
        this.gcbsParam.pageSize = val;
        this.getdetail();
      },
      handleCurrentChange(val) {
        this.gcbsParam.pageNum = val;
        this.getdetail(false);
      },
  
      //验证部分
      analysisIdCard(rule, value, callback) {
        let index = rule.field.split('params.')[1].split('.insuredCardNo')[0];
        let type = this.addJsonForm.params[index].insuredCardType;
        if (type == '01'||type =='11'||type =='12') {
          //是身份证类型
          if (value.length != 18) {
            callback(new Error('证件号码位数不正确'));
          } else {
            if (validateIdCard(value)) {
              var year = value.substr(6, 4);
              var month = value.substr(10, 2);
              var day = value.substr(12, 2);
              var sex = value.substr(16, 1);
              this.addJsonForm.params[index].birthday = year + '-' + month + '-' + day;
              this.addJsonForm.params[index].gender = sex % 2 == 0 ? '2' : '1';
              this.addJsonForm.params[index].disable = true;
              callback();
            } else {
              callback(new Error('证件号码无法识别，请输入正确号码'));
            }
          }
        } else {
          callback();
        }
      },
      gobackEdit() {
        preservationedit({ preservationId: this.$route.query.preservationId }).then((res) => {
          if (res) {
            this.showEdited = true;
            this.getAll();
          }
        });
      },
    },
    created() {
      // this.getdetail();
      let { from } = this.$route.query;
      from && this.getAll();
      this.getplan();
      this.nationInit()
    },
  };
  </script>
  <style lang="less" scoped>
  .addinsurer {
    .actions {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #aaaaaf;
      line-height: 14px;
      margin-bottom: 10px;
    }
    .addtable {
      width: 100%;
      overflow-x: auto;
      margin-top: 18px;
      .form-head {
        white-space: nowrap;
        height: 42px;
        line-height: 42px;
        background: #fafafa;
        border: 1px solid #dcdce1;
        span {
          display: inline-block;
          width: 130px;
          text-align: center;
          font-size: 14px;
          i {
            color: rgba(255, 67, 76, 1);
          }
        }
      }
      .demo-form-inline {
        white-space: nowrap;
      }
    }
  }
  .upload-demo {
    display: inline-block;
    margin-right: 20px;
  }
  .save-btn {
    margin-top: 30px;
  }
  /deep/.el-tabs--border-card > .el-tabs__content {
    padding: 20px 33px;
  }
  /deep/.el-upload-list.el-upload-list--text {
    display: inline-block;
    vertical-align: bottom;
    border: 1px solid #dcdce1;
    margin-left: 12px;
  }
  /deep/.el-upload-list__item:first-child {
    margin: 0;
  }
  /deep/.el-tabs__nav-scroll {
    background: white;
    border-bottom: 2px solid rgba(226, 124, 0, 1);
  }
  /deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    background: #e27c00;
    color: white;
    &:hover {
      color: white;
    }
  }
  /deep/.el-button--primary.is-plain:hover {
    color: #e27c00;
  }
  /deep/.el-button--primary.is-plain:active {
    color: #e27c00;
  }
  /deep/.el-button--primary.is-plain:focus {
    color: #e27c00;
  }
  </style>